export default class hamburger {

  constructor() {
    this.menuCont = document.getElementById('js-menu');
    this.menuBtn = document.getElementById('js-menuBtn');
    this.init();
  }

  init() {
    let _self = this;
    _self.botton();
    _self.esc();
  }

  // OPEN処理
  botton() {
    let _self = this;
    _self.menuBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!_self.menuCont.classList.contains('is-open')) {
        _self.menuCont.classList.add('is-open');
        _self.menuBtn.classList.add('is-open');
      } else {
        _self.close();
      }
    })
  }

  // escでクローズ処理
  esc() {
    let _self = this;
    window.addEventListener('keyup', function (e) {
      if (e.keyCode == 27) {
        _self.close();
      }
    });
    window.onpageshow = function (event) {
      _self.menuCont.classList.remove('is-open');
      _self.menuBtn.classList.remove('is-open');
    };
  }

  // クローズ処理
  close() {
    let _self = this;
    _self.menuCont.classList.remove('is-open');
    _self.menuBtn.classList.remove('is-open');
  }

}